import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import UncontrolledAccionaTable from '../../../../../../../components/AccionaTable/UncontrolledTable';
import { getBackgroundColorByObservation } from '../../../shared/utils.index';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { getScannedDocumentByMysqlIDAndPidAndModel } from '../../../../../../../services/api/scannedDocuments';
import styles from './index.module.scss';

const { link } = styles;

const StrengthTestTable = ({ data, days, title, totalCount }) => {
  const intl = useIntl();
  const is28Days = days === 28;
  const isStandardDay = [3, 7, 28, 60].includes(days);
  const { project } = useOutletContext() || {};
  const navigate = useNavigate();

  const getColumns = () => {
    const baseColumns = {
      batch_code: {
        dataIndex: 'batch_code',
        key: 'batch_code',
        title: intl.formatMessage({
          id: 'pages.quality.normative.100-control.batchDetail.table.batch_code',
          defaultMessage: 'Código lote',
        }),
        width: '10%',
        align: 'center',
      },
      reference_number: {
        dataIndex: 'reference_number',
        key: 'reference_number',
        title: intl.formatMessage({
          id: 'pages.quality.normative.100-control.batchDetail.table.reference_number',
          defaultMessage: 'Referencia Ensayo',
        }),
        width: '10%',
        align: 'center',
      },
    };

    if (is28Days) {
      return {
        ...baseColumns,
        position_order: {
          dataIndex: 'position_order',
          key: 'position_order',
          title: (
            <span style={{ textTransform: 'none' }}>
              {intl.formatMessage({
                id: 'pages.quality.normative.100-control.batchDetail.table.order_xi',
                defaultMessage: 'Orden',
              })}{' '}
              X<sub>i</sub> 28d
              <br /> TOTAL N={totalCount || 0}
            </span>
          ),
          width: '100px',
        },
        compressive_strength_1: {
          width: '10%',
          align: 'center',
          dataIndex: 'compressive_strength_1',
          key: 'compressive_strength_1',
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.pb1',
            defaultMessage: 'pb1',
          }),
        },
        compressive_strength_2: {
          width: '10%',
          align: 'center',
          dataIndex: 'compressive_strength_2',
          key: 'compressive_strength_2',
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.pb2',
            defaultMessage: 'pb2',
          }),
        },
        compressive_strength_3: {
          width: '10%',
          align: 'center',
          dataIndex: 'compressive_strength_3',
          key: 'compressive_strength_3',
          title: intl.formatMessage({
            id: 'pages.quality.normative.100-control.batchDetail.table.pb3',
            defaultMessage: 'pb3',
          }),
        },
        ave_strength: {
          width: '10%',
          align: 'center',
          dataIndex: 'ave_strength',
          key: 'ave_strength',
          title: (
            <>
              x<sub style={{ textTransform: 'none' }}>i</sub> {days}{' '}
              {intl.formatMessage({ id: 'days' })}
            </>
          ),
        },
        scatter_2: {
          dataIndex: 'scatter_2',
          key: 'scatter_2',
          title: (
            <span style={{ textTransform: 'none' }}>
              {intl.formatMessage({
                id: 'pages.quality.normative.100-control.batchDetail.table.scatter_2',
                defaultMessage: 'Dispersión 2 Pb',
              })}{' '}
              [&lt;0,13]
            </span>
          ),
          width: '11%',
          align: 'center',
        },
        scatter_3: {
          dataIndex: 'scatter_3',
          key: 'scatter_3',
          title: (
            <span style={{ textTransform: 'none' }}>
              {intl.formatMessage({
                id: 'pages.quality.normative.100-control.batchDetail.table.scatter_3',
                defaultMessage: 'Dispersión 3 Pb',
              })}{' '}
              [&lt;0,20]
            </span>
          ),
          width: '11%',
          align: 'center',
        },
        observation: {
          dataIndex: 'observation',
          width: '10%',
          align: 'center',
          key: 'observation',
          title: (
            <>
              {intl.formatMessage({
                id: 'pages.quality.normative.100-control.batchDetail.table.compliance_dispersion',
                defaultMessage: 'CUMPLIMIENTO Dispersión',
              })}
              <br />
              [Art.86.3.2]
            </>
          ),
          cellBackgroundFn: (value) => {
            const observation =
              value.laboratory_note_data?.[`observation_${days}`];
            return getBackgroundColorByObservation(observation);
          },
        },
      };
    }

    return {
      ...baseColumns,
      none: { title: ' ', width: '100px' },
      compressive_strength_1: {
        width: '10%',
        align: 'center',
        dataIndex: 'compressive_strength_1',
        key: 'compressive_strength_1',
        title: intl.formatMessage({
          id: 'pages.quality.normative.100-control.batchDetail.table.pb1',
          defaultMessage: 'pb1',
        }),
      },
      compressive_strength_2: {
        width: '10%',
        align: 'center',
        dataIndex: 'compressive_strength_2',
        key: 'compressive_strength_2',
        title: intl.formatMessage({
          id: 'pages.quality.normative.100-control.batchDetail.table.pb2',
          defaultMessage: 'pb2',
        }),
      },
      compressive_strength_3: {
        width: '10%',
        align: 'center',
        dataIndex: 'compressive_strength_3',
        key: 'compressive_strength_3',
        title: intl.formatMessage({
          id: 'pages.quality.normative.100-control.batchDetail.table.pb3',
          defaultMessage: 'pb3',
        }),
      },
      ave_strength: {
        width: '10%',
        align: 'center',
        dataIndex: 'ave_strength',
        key: 'ave_strength',
        title: (
          <>
            x<sub style={{ textTransform: 'none' }}>i</sub> {days} {intl.formatMessage({ id: 'days' })}
          </>
        ),
      },
      none1: { title: ' ', width: '10%' },
      none2: { title: ' ', width: '10%' },
      observation: {
        dataIndex: 'observation',
        width: '10%',
        align: 'center',
        key: 'observation',
        title: intl.formatMessage({
          id: 'pages.quality.normative.100-control.batchDetail.table.result',
          defaultMessage: 'Resultado',
        }),
        cellBackgroundFn: (value) => {
          const observation = value.observation;
          return getBackgroundColorByObservation(observation);
        },
      },
    };
  };

  return (
    <UncontrolledAccionaTable
      layout="fixed"
      showPagination={false}
      title={title}
      pageSize={data?.length}
      total={data?.length}
      items={data || []}
      dataParseFunction={(data) => {
        return data.map((d, i) => {
          const labData = d.laboratory_note_data;
          const strengthExtra = labData?.strength_extra || {};
          const getObservation = () => {
            if (isStandardDay) {
              return labData?.[`observation_${days}`];
            } else {
              return strengthExtra[`observation_${days}`];
            }
          };

          const getAveStrength = () => {
            if (is28Days) {
              return (
                labData?.[`ave_strength_${days}_2`]?.toFixed(2) ||
                labData?.[`ave_strength_${days}_3`]?.toFixed(2)
              );
            } else if (isStandardDay) {
              return labData?.[`ave_strength_${days}`]?.toFixed(2);
            } else {
              return strengthExtra[`ave_strength_${days}`]?.toFixed(2);
            }
          };
          const getCompressiveStrength = (index) => {
            if (isStandardDay) {
              return labData?.[
                `compressive_strength_${days}_${index}`
              ]?.toFixed(2);
            } else {
              return strengthExtra[
                `compressive_strength_${days}_${index}`
              ]?.toFixed(2);
            }
          };
          return {
            ...d,
            rawData: d,
            batch_code:
              project.version === 1
                ? d.batch_code
                : `${d.tag_batch_data?.tag_data.name} ${d.tag_batch_data?.tag_number}`,
            reference_number: d.laboratory_note_data?.reference_number ? (
              <span
                className={link}
                onClick={async () => {
                  getScannedDocumentByMysqlIDAndPidAndModel(
                    d.laboratory_note_data?.id,
                    project.id_project,
                    'laboratory',
                  ).then((res) => {
                    const lab = res.data.data;
                    navigate(
                      `../../ocr/scannedDocuments/scannedDocumentsRC/document/laboratory/${lab[0].id}/${d.laboratory_note_data?.id}/${lab[0].fileName}/`,
                    );
                  });
                }}
              >
                {d.laboratory_note_data?.reference_number}
              </span>
            ) : (
              '--'
            ),
            position_order: is28Days
              ? `POS ${i + 1}.- ${d.posicion_orden_xi || ''}`
              : undefined,
            compressive_strength_1: getCompressiveStrength(1),
            compressive_strength_2: getCompressiveStrength(2),
            compressive_strength_3: getCompressiveStrength(3),
            ave_strength: getAveStrength(),
            scatter_2: is28Days
              ? d.laboratory_note_data?.scatter_28_2?.toFixed(3)
              : undefined,
            scatter_3: is28Days
              ? d.laboratory_note_data?.scatter_28_3?.toFixed(3)
              : undefined,
            observation: getObservation(),
          };
        });
      }}
      columns={getColumns()}
    />
  );
};

StrengthTestTable.propTypes = {
  data: PropTypes.array,
  days: PropTypes.number.isRequired,
  title: PropTypes.string,
  totalCount: PropTypes.number,
};

StrengthTestTable.defaultProps = {
  data: [],
  title: '',
  totalCount: 0,
};

export default StrengthTestTable;
